module.exports = __webpack_public_path__ + "static/media/Tawuniya-Logo.0f06485f.svg";